export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8923.88464e51.jpg";